import StateProvinceSelectionSlide from "./StateProvinceSelectionSlide";

export default StateProvinceSelectionSlide;
